// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#newsBackDrop {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.3);
  overflow: hidden;
  z-index: 99998;
}

#newsFrame {
  width: 690px;
  height: 420px;
  position: fixed;
  background-color: #000;
  padding: 0;
  z-index: 99999;
  cursor: default;
  border-radius: 5px;
  top: calc(50% - 270px);
  left: calc(50% - 500px);
}

#innerFrameContainer {
  position: relative;
  height: 100%;
  width: 100%;
}

#innerFrame {
  position: absolute;
  background-color: rgb(41, 42, 47);
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  user-select: none;
}

.x-close {
  font-size: 20pt;
  position: absolute;
  z-index: 10;
  right: 4px;
  color: #ffffff;
  top: 3px;
}

.leftCol {
  padding: 20px;
  width: 60%;
  height: 100%;
}

.rightCol {
  background-color: #595959;
  color: #ffffff;
  padding: 20px;
  width: 40%;
  height: 100%;
}

.fakeLink {
  font-size: 8pt;
}

#close {
  position: absolute;
  bottom: 5px;
  left: 215px;
}

@media (max-width: 800px) {
  #newsFrame {
    width: 700px;
    left: calc(50% - 350px);
  }
  .fakeLink {
    font-size: 7pt;
  }
  ::ng-deep #newsFrame mat-carousel h2 {
    font-size: 17px;
  }
  ::ng-deep #newsFrame mat-carousel ul li {
    font-size: 13px;
  }
}
::ng-deep .carousel {
  width: calc(100% + 1px) !important;
}

/**
::ng-deep .carousel > button {
    display: none;
    top: auto !important;
    bottom: -10px !important;
}

::ng-deep .carousel > button:first-of-type {
    left: 61px !important;
    bottom: 40px !important;
}

::ng-deep .carousel > button:last-of-type {
    left: 155px !important;
    bottom: 40px !important;
}

::ng-deep .mat-icon-button .mat-icon,
::ng-deep .mat-icon-button i {
    line-height: 23px !important;
}*/
::ng-deep .carousel > button:first-of-type {
  left: 0 !important;
}

::ng-deep .carousel > button:last-of-type {
  right: 0 !important;
}

::ng-deep .mat-icon-button {
  line-height: 23px !important;
  background: 0;
  border: 1px solid red;
  width: 70px;
  height: 70px;
}

::ng-deep .mat-icon-button .mat-icon {
  display: none;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/components/carousel/carousel.component.scss"],"names":[],"mappings":"AAAA;EACI,eAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,oCAAA;EACA,gBAAA;EACA,cAAA;AACJ;;AAEA;EACI,YAAA;EACA,aAAA;EACA,eAAA;EACA,sBAAA;EACA,UAAA;EACA,cAAA;EACA,eAAA;EACA,kBAAA;EACA,sBAAA;EACA,uBAAA;AACJ;;AAEA;EACI,kBAAA;EACA,YAAA;EACA,WAAA;AACJ;;AAEA;EACI,kBAAA;EACA,iCAAA;EACA,MAAA;EACA,QAAA;EACA,OAAA;EACA,SAAA;EACA,2BAAA;EACA,yBAAA;EAGA,iBAAA;AACJ;;AAEA;EACI,eAAA;EACA,kBAAA;EACA,WAAA;EACA,UAAA;EACA,cAAA;EACA,QAAA;AACJ;;AAEA;EACI,aAAA;EACA,UAAA;EACA,YAAA;AACJ;;AAEA;EACI,yBAAA;EACA,cAAA;EACA,aAAA;EACA,UAAA;EACA,YAAA;AACJ;;AAEA;EACI,cAAA;AACJ;;AAEA;EACI,kBAAA;EACA,WAAA;EACA,WAAA;AACJ;;AAEA;EAEI;IACI,YAAA;IACA,uBAAA;EAAN;EAGE;IACI,cAAA;EADN;EAIE;IACI,eAAA;EAFN;EAKE;IACI,eAAA;EAHN;AACF;AAMA;EACI,kCAAA;AAJJ;;AAMA;;;;;;;;;;;;;;;;;;;;EAAA;AAsBA;EACI,kBAAA;AAJJ;;AAOA;EACI,mBAAA;AAJJ;;AAOA;EACI,4BAAA;EACA,aAAA;EACA,qBAAA;EACA,WAAA;EACA,YAAA;AAJJ;;AAOA;EACI,aAAA;AAJJ","sourcesContent":["#newsBackDrop {\n    position: fixed;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background-color: rgba(0, 0, 0, 0.3);\n    overflow: hidden;\n    z-index: 99998;\n}\n\n#newsFrame {\n    width: 690px;\n    height: 420px;\n    position: fixed;\n    background-color: #000;\n    padding: 0;\n    z-index: 99999;\n    cursor: default;\n    border-radius: 5px;\n    top: calc(50% - (540px / 2));\n    left: calc(50% - (1000px / 2));\n}\n\n#innerFrameContainer {\n    position: relative;\n    height: 100%;\n    width: 100%;\n}\n\n#innerFrame {\n    position: absolute;\n    background-color: rgb(41,42,47);\n    top: 0;\n    right: 0;\n    left: 0;\n    bottom: 0;\n    -webkit-touch-callout: none;\n    -webkit-user-select: none;\n    -moz-user-select: none;\n    -ms-user-select: none;\n    user-select: none;\n}\n\n.x-close {\n    font-size: 20pt;\n    position: absolute;\n    z-index: 10;\n    right: 4px;\n    color: #ffffff;\n    top: 3px;\n}\n\n.leftCol {\n    padding: 20px;\n    width: 60%;\n    height: 100%;\n}\n\n.rightCol {\n    background-color: #595959;\n    color: #ffffff;\n    padding: 20px;\n    width: 40%;\n    height: 100%;\n}\n\n.fakeLink {\n    font-size: 8pt;\n}\n\n#close {\n    position: absolute;\n    bottom: 5px;\n    left: 215px;\n}\n\n@media (max-width: 800px) {\n\n    #newsFrame {\n        width: 700px;\n        left: calc(50% - (700px / 2));\n    }\n\n    .fakeLink {\n        font-size: 7pt;\n    }\n\n    ::ng-deep #newsFrame mat-carousel h2 {\n        font-size: 17px;\n    }\n\n    ::ng-deep #newsFrame mat-carousel ul li {\n        font-size: 13px;\n    }\n}\n\n::ng-deep .carousel {\n    width: calc(100% + 1px) !important;\n}\n/**\n::ng-deep .carousel > button {\n    display: none;\n    top: auto !important;\n    bottom: -10px !important;\n}\n\n::ng-deep .carousel > button:first-of-type {\n    left: 61px !important;\n    bottom: 40px !important;\n}\n\n::ng-deep .carousel > button:last-of-type {\n    left: 155px !important;\n    bottom: 40px !important;\n}\n\n::ng-deep .mat-icon-button .mat-icon,\n::ng-deep .mat-icon-button i {\n    line-height: 23px !important;\n}*/\n\n::ng-deep .carousel>button:first-of-type {\n    left: 0!important;\n}\n\n::ng-deep .carousel>button:last-of-type {\n    right: 0!important;\n}\n\n::ng-deep .mat-icon-button {\n    line-height: 23px !important;\n    background: 0;\n    border: 1px solid red;\n    width: 70px;\n    height: 70px;\n}\n\n::ng-deep .mat-icon-button .mat-icon {\n    display: none;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
